import { useState } from "react";
import { Badge, Button, CloseButton, Form, InputGroup } from "react-bootstrap";
import {toast} from "react-toastify";

const TagManager = ({ header, tags = [], setTags }) => {
    const [value, setValue] = useState("");
    const [error, setError] = useState("");

    const handleAdd = () => {
        const newTag = value.trim();
        if (!newTag) return toast.error("Η ετικέτα δεν μπορεί να είναι άδεια.");
        const exists = tags.some((t) => t.toLowerCase() === newTag.toLowerCase());
        if (exists) return toast.error("Υπάρχει ήδη αυτή η ετικέτα.");
        setTags([...tags, newTag]);
        setValue("");
    };

    const handleDelete = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    };

    return (
        <div className={"mb-3"}>
            <div>
                <Form.Label>{header}</Form.Label>
                <InputGroup hasValidation>
                    <Form.Control
                        type={"text"}
                        placeholder={"Εισαγωγή νέας ετικέτας"}
                        value={value}
                        isInvalid={!!error}
                        onChange={(e) => {
                            setValue(e.target.value);
                            if (error) setError("");
                        }}
                        onKeyDown={(e) => {
                            if (e?.key === "Enter") handleAdd();
                        }}
                    />
                    <Button size={"sm"} variant="primary" onClick={() => handleAdd()}>
                        Προσθήκη ετικέτας
                    </Button>
                </InputGroup>
            </div>

            {tags.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                    {tags.map((tag, index) => (
                        <Badge
                            key={`${tag}-${index}`}
                            bg="secondary"
                            className="d-flex align-items-center gap-2 fs-6 fw-normal"
                        >
                            {tag}
                            <CloseButton
                                variant="white"
                                title={`Διαγράφη ετικέτας ${tag}`}
                                onClick={() => handleDelete(index)}
                            />
                        </Badge>
                    ))}
                </div>
            )}
        </div>
    );
}

export default TagManager;
